import LegacyLabel, { LegacyLabelProps } from './LegacyLabel';
import Label, { labelTheme } from './Label';

export default LegacyLabel;
export { labelTheme, Label };
export type { LegacyLabelProps };
